/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerVoterDB_Voters.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Voters
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, September 30, 2019 - 09:59:53 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      09/30/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    VOTER_LIST_CONTAINER_LOADED,
    VOTER_LIST_CONTAINER_UNLOADED,
    VOTER_LIST_TABLE_LOADED,
    VOTER_LIST_TABLE_UNLOADED,

    VOTER_SELECT_ROW,
    VOTER_ADD,
    VOTER_EDIT,
    VOTER_DELETE,
    VOTER_OPEN_WARNING,
    VOTER_CLOSE_WARNING,
    VOTER_DELETE_DISABLE,

    VOTER_UPDATE_VALUE,

    VOTER_EDIT_CONTAINER_LOADED,
    VOTER_EDIT_CONTAINER_UNLOADED,
    VOTER_EDIT_FORM_LOADED,
    VOTER_EDIT_FORM_UNLOADED,
    VOTER_EDIT_DATA_LOAD,
    VOTER_EDIT_CONTAINER_SUBMIT,
    VOTER_EDIT_CONTAINER_CANCEL,
    VOTER_SET_GROUP_SELECT
} from '../constants/actionTypeVoterDB_Voters';

const defaultState = {
    refreshList: false,
    danger: false,
    voterCount: 0,
    countries: [],
    states: [],
    counties: [],
    precinctgroups: [],
    precincts: [],
    voterid: 0,
    fileid: 0,
    countyid: 0,
    precinctid: 0,
    voteruid: 0,
    firstname: '',
    middlename: '',
    lastname: '',
    suffix: '',
    genderid: 0,
    dob: '',
    address1: '',
    address2: '',
    city: '',
    stateid: 0,
    zipcode: '',
    mailaddress1: '',
    mailaddress2: '',
    mailcity: '',
    mailstateid: 0,
    mailzipcode: '',
    edr: '',
    statusid: 0,
    hispanicid: 0,
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case VOTER_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                voterCount: action.payload[0] ? action.payload[0].results.recordcount : null,
                countries: action.payload[1] ? action.payload[1].records : [],
                states: action.payload[2] ? action.payload[2].records : [],
                counties: action.payload[3] ? action.payload[3].records : [],
                precinctgroups: action.payload[4] ? action.payload[4].records : [],
                precincts: action.payload[5] ? action.payload[5].records : [],
            }
        case VOTER_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case VOTER_UPDATE_VALUE:
            return {
                ...state,
                [action.key]: action.value
            }
        case VOTER_SET_GROUP_SELECT:
            return {
                ...state,
                [action.key]: action.payload
            }
        case VOTER_SELECT_ROW:
            return {
                ...state,
                voterid: action.id
            }
        case VOTER_ADD:
            return {
                ...state
            }
        case VOTER_EDIT:
            return {
                ...state,
                voterid: action.id
            }
        case VOTER_DELETE:
            return {
                ...state,
                voterid: null
            }
        case VOTER_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case VOTER_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case VOTER_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case VOTER_EDIT_CONTAINER_LOADED:
        case VOTER_EDIT_DATA_LOAD:
            return {
                ...state,
                voterid: action.payload[0] ? action.payload[0].voterid : 0,
                fileid: action.payload[0] ? action.payload[0].fileid : 0,
                countyid: action.payload[0] ? action.payload[0].countyid : 0,
                precinctid: action.payload[0] ? action.payload[0].precinctid : 0,
                voteruid: action.payload[0] ? action.payload[0].voteruid : 0,
                firstname: action.payload[0] ? action.payload[0].firstname : '',
                middlename: action.payload[0] ? action.payload[0].middlename : '',
                lastname: action.payload[0] ? action.payload[0].lastname : '',
                suffix: action.payload[0] ? action.payload[0].suffix : 0,
                genderid: action.payload[0] ? action.payload[0].genderid : 0,
                dob: action.payload[0] ? action.payload[0].dob : '',
                address1: action.payload[0] ? action.payload[0].address1 : '',
                address2: action.payload[0] ? action.payload[0].address2 : '',
                city: action.payload[0] ? action.payload[0].city : '',
                stateid: action.payload[0] ? action.payload[0].stateid : 0,
                zipcode: action.payload[0] ? action.payload[0].zipcode : '',
                mailaddress1: action.payload[0] ? action.payload[0].mailaddress1 : '',
                mailaddress2: action.payload[0] ? action.payload[0].mailaddress2 : '',
                mailcity: action.payload[0] ? action.payload[0].mailcity : '',
                mailstateid: action.payload[0] ? action.payload[0].mailstateid : 0,
                mailzipcode: action.payload[0] ? action.payload[0].mailzipcode : '',
                edr: action.payload[0] ? action.payload[0].edr : '',
                statusid: action.payload[0] ? action.payload[0].statusid : 0,
                hispanicid: action.payload[0] ? action.payload[0].hispanicid : 0,
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case VOTER_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case VOTER_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case VOTER_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case VOTER_LIST_CONTAINER_UNLOADED:
        case VOTER_LIST_TABLE_UNLOADED:
        case VOTER_EDIT_CONTAINER_UNLOADED:
        case VOTER_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerVoterDB_Voters.js